import { z } from "zod";
import { AggregatedStats } from "@epicgames-ps/lib-pixelstreamingfrontend-ue5.5";

export const ZStats = z.object({
  type: z.literal("stats"),
  stats: z
    .object({
      /**
       * Other known properties.
       */
      codecs: z.custom<AggregatedStats["codecs"]>(),
      candidatePair: z.custom<AggregatedStats["candidatePairs"]>(),
      localCandidates: z.custom<AggregatedStats["localCandidates"]>(),
      remoteCandidates: z.custom<AggregatedStats["remoteCandidates"]>(),
      DataChannelStats: z.custom<AggregatedStats["datachannelStats"]>(),


      // Received (last) for ticket
      bytesReceived: z.number(),
      // Packets Lost (last) for ticket
      packetsLost: z.number(),
      // Video resolution: highest lowest average (portrait) and highest lowest average (landscape) for ticket
      frameWidth: z.number(),
      // Video resolution: highest lowest average (portrait) and highest lowest average (landscape) for ticket
      frameHeight: z.number(),
      // Frames decoded (Last) for ticket
      framesDecoded: z.number(),
      // Framerate (low / high, avg) for ticket
      framesPerSecond: z.number(),
      // frames dropped (last) for ticket
      framesDropped: z.number(),
      // Videocodec (once) for ticket
      videoCodec: z.string(),
      // audiocodec (once) for ticket
      audioCodec: z.string(),
      // browser type and version for ticket (arcware / addition)
      browserInfo: z
        .object({
          userAgent: z.string(),
          platform: z.string().nullable(),
          language: z.string(),
        })
        .passthrough()
        .partial(),
      // Net RTT (low, high, avg)
      currentRTT: z.number(),
      // Duration (last)
      sessionRunTime: z.string(),
      // Controls stream input (??)
      controlsStreamInput: z.string().refine((arg) => arg === "true" || arg === "false"),
      // video quantization parameter (low / high / avg if applicable)
      videoEncoderAvgQP: z.number(),
      // Video bitrate (min / max / avg)
      videoBitrate: z.number(),
      // Audio bitrate (min / max / avg)
      audioBitrate: z.number(),
    })
    .passthrough()
    .partial(),
});
export type Stats = z.infer<typeof ZStats>;
